import React from 'react'
import VMSubMenu from 'FoundationalComponents/AssetSubMenus/VM'
import Table from 'UI/Table'
import { compact, map, sortBy, uniqBy } from 'lodash'

const VMTable = ({ data }) => (
  <Table {...{
    data,
    columns: [
      { Header: 'Location', accessor: 'location_name', width: 200 },
      { Header: 'Customer', accessor: 'customer_name' },
      { Header: 'Power', accessor: 'power_state', type: 'powerState' },
      { Header: 'Device', accessor: 'name', Cell: ({ original }) => <VMSubMenu vm={original} /> },
      { Header: 'OS Data Source', accessor: 'machine_type_source', width: 150 },
      { Header: 'Operating System', accessor: 'operating_system' },
      {
        Header: 'OS Version', accessor: 'operating_system_version', type: 'number', width: 100,
        filterMethod: (filter, row) => {
          if (filter.value === "all") { return true }

          return row[filter.id] === filter.value
        },
        Filter: ({ filter, onChange }) => (
          <select onChange={event => onChange(event.target.value)} style={{ width: "100%" }} value={filter ? filter.value : "all"}>
            <option value="all">Show All</option>
            {map(sortBy(uniqBy(compact(map(data, 'operating_system_version'))), parseFloat), version => <option value={version}>{version}</option>)}
          </select>
        )
      },
      { Header: 'OS Build', accessor: 'operating_system_build', type: 'number', width: 100 },
      { Header: 'CPU Cores', accessor: 'num_cpu', type: 'number' },
    ],
    filterable: true,
    showPagination: false,
    defaultPageSize: data.length,
  }} />
)

export default VMTable
